//User details data 
export const userDetailsItemData = [
    {
        title: "Personal Information",
        children: [
            {
                childTitle: "full Name",
                childValue: "Grace Effiom"
            },
            {
                childTitle: "Phone Number",
                childValue: "07060780922"
            },
            {
                childTitle: "Email Address",
                childValue: "grace@gmail.com"
            },
            {
                childTitle: "Bvn",
                childValue: "07060780922"
            },
            {
                childTitle: "Gender",
                childValue: "Female"
            },
            {
                childTitle: "Marital status",
                childValue: "Single"
            },
            {
                childTitle: "Children",
                childValue: "None"
            },
            {
                childTitle: "Type of residence",
                childValue: "Parent’s Apartment"
            },
        ]
    },
    {
        title: "Education and Employment",
        children: [
            {
                childTitle: "level of education",
                childValue: "B.Sc"
            },
            {
                childTitle: "employment status",
                childValue: "Employed"
            },
            {
                childTitle: "sector of employment",
                childValue: "FinTech"
            },
            {
                childTitle: "Duration of employment",
                childValue: "2 years"
            },
            {
                childTitle: "office email",
                childValue: "grace@lendsqr.com"
            },
            {
                childTitle: "Monthly income",
                childValue: "₦200,000.00- ₦400,000.00"
            },
            {
                childTitle: "loan repayment",
                childValue: "40,000"
            },
        ]
    },
    {
        title: "Socials",
        children: [
            {
                childTitle: "Twitter",
                childValue: "@grace_effiom"
            },
            {
                childTitle: "Facebook",
                childValue: "Grace Effiom"
            },
            {
                childTitle: "Instagram",
                childValue: "@grace_effiom"
            },
        ]
    },
    {
        title: "Guarantor",
        children: [
            {
                childTitle: "full Name",
                childValue: "Debby Ogana"
            },
            {
                childTitle: "Phone Number",
                childValue: "07060780922"
            },
            {
                childTitle: "Email Address",
                childValue: "debby@gmail.com"
            },
            {
                childTitle: "Relationship",
                childValue: "Sister"
            },
        ]
    },
]